export default "__VITE_ASSET__DzPqnl2h__ 150w, __VITE_ASSET__CvCQWgMk__ 300w, __VITE_ASSET__$zkkuY3g__ 450w";